import { createActionTypes } from '../../../../util/createActionsHelpers';

export const GET_BEST_WRITERS = createActionTypes('GET_BEST_WRITERS');
